import { render, staticRenderFns } from "./xingji.vue?vue&type=template&id=7248b23e&scoped=true"
import script from "./xingji.vue?vue&type=script&lang=js"
export * from "./xingji.vue?vue&type=script&lang=js"
import style0 from "./xingji.vue?vue&type=style&index=0&id=7248b23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7248b23e",
  null
  
)

export default component.exports